<span class="pie" [hamTooltip]="'abcp_accounts_group_status_tooltip' | i18next: counts" tooltipClass="abcp">
    <!-- Half a unit of margin: a disc touching the edge loses pixels at fractional positions. -->
    <svg viewBox="-0.5 -0.5 17 17" aria-hidden="true">
        <ng-container *ngFor="let layer of layers">
            <svg:circle *ngIf="layer.path === null" cx="8" cy="8" r="8" [attr.class]="'pie__' + layer.status" />
            <svg:path *ngIf="layer.path !== null" [attr.d]="layer.path" [attr.class]="'pie__' + layer.status" />
        </ng-container>
    </svg>
</span>
